import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import {LoginData} from './dto/login-data';
import {TokenCredentials} from './dto/token-credentials';
import {MenuItem} from './dto/menu-item'
import {User} from './dto/user'

/*
  Generated class for the SharedData provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class SharedDataProvider {

  private loginData: LoginData;
  private loginUser: User;
  public testVariable = "Test!23";

  private mainMenuItems: MenuItem[];

  constructor() {
    this.loginData = { credentials: { username: "", userId: 0, token: "" }, isLoggedIn: false };
    this.mainMenuItems = [];
    this.loginUser = new User();

    console.log("Try to load data from session.");
    let loginData = sessionStorage.getItem('pl-logindata');
    if (loginData != null) {
      this.loginData = JSON.parse(loginData);
    }

    console.log("Is menue stored?");
    let mainMenuItems = sessionStorage.getItem('pl-mainmenuitems');
    if (mainMenuItems != null && this.loginData.isLoggedIn) {
      this.mainMenuItems = JSON.parse(mainMenuItems);
    }
  }

  public getMainMenuItems() : MenuItem[]
  {
    return this.mainMenuItems;
  }

  public setMainMenuItems(mainMenuItems : MenuItem[])
  {
    this.mainMenuItems = mainMenuItems;
    sessionStorage.setItem('pl-mainmenuitems', JSON.stringify(this.mainMenuItems));
  }

  public getLoginUser() : User {
    return this.loginUser;
  }

  public setLoginUser(pUser : User) {
    this.loginUser = pUser;
  }

  public setLoginData(loginData: LoginData) {
    this.loginData = loginData;
    sessionStorage.setItem('pl-logindata', JSON.stringify(this.loginData));
    console.log('Login data is stored in session.');
  }

  public getLoginData() : LoginData 
  {
    return this.loginData;
  }

  public getTokenAuthData(): TokenCredentials {
    return this.loginData.credentials;
  }

}



// WEBPACK FOOTER //
// ./src/providers/shared-data-provider.ts